









































































































































































































































































































































import Vue from 'vue'

import Artifacts from '@/components/artifacts/Artifacts.tsx'
import PastLetter from '@/components/PastLetter.vue'
import Report from '@/components/interviews/Report.vue'
import PostReport from '@/components/interviews/PostReport.vue'

import { AxiosInstance } from 'axios'

import { CaseLogsForInterviewReportQuery } from '@/graphql-schema'
import { CaseLogsForInterviewReport } from './Case.graphql'

import { ProcessLog } from '@/graphql-schema'
import { CaseDetails } from './Case.graphql'
import { CaseDetailsQuery } from '@/graphql-schema'
import { CaseWithMessages } from '@/queries/cases.graphql'
import { queryBookingInfoByCaseId } from '@/store/interview/queries.graphql'

import Collapsible from '@/components/layout/Collapse.vue'
import treatment from '@/routing/treatment'
import SuicidalCall from './SuicidalCall.vue'
import CounselingQuestionTexts from '@/components/counseling/CounselingQuestionTexts.vue'

export type CaseReport = NonNullable<CaseDetailsQuery['caseReport']>
export type Demographics = NonNullable<CaseReport['demographics']['nodes'][0]>

export default Vue.extend({
  components: {
    CounselingQuestionTexts,
    Artifacts,
    PastLetter,
    Report,
    PostReport,
    Collapsible,
    SuicidalCall,
  },
  apollo: {
    caseReport: {
      query: CaseDetails,
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
    pickedCase: {
      query: CaseWithMessages,
      variables() {
        return {
          id: this.caseId,
        }
      },
    },
    logs: {
      query: CaseLogsForInterviewReport,
      variables() {
        return {
          id: this.$route.params.caseId,
        }
      },
    },
    bookings: {
      query: queryBookingInfoByCaseId,
      variables() {
        return {
          caseId: this.caseId,
        }
      },
    },
  },
  computed: {
    firstTreatment() {
      if (this.logs && this.logs.nodes.length > 0) {
        const treatmentList = this.logs.nodes.filter(
          (i: { taskId: string }) =>
            i.taskId === 'do-cbt-treatment' ||
            i.taskId === 'do-ipt-treatment' ||
            i.taskId === 'do-expo-treatment' ||
            i.taskId === 'do-cr-treatment'
        )
        if (treatmentList.length > 0) {
          return treatmentList[0]
        }
      }
      return null
    },
    currentUserIsCoordinator(): boolean {
      return (
        this.$store.getters.currentUser && this.$store.getters.currentUser.is_coordinator_account
      )
    },
    hasFinalReport(): boolean {
      return this.pickedCase?.excludeFromAnalysis != null
    },
    excludedFromAnalysis(): boolean {
      return this.pickedCase?.excludeFromAnalysis
    },
    reasonForExclusion(): string {
      return this.pickedCase?.reasonForExclusion
    },
    letters(): any[] {
      return this.$store.getters.pastLettersForMembersAndCaseId(
        this.pickedCase?.members?.node || [],
        this.caseId
      )
    },
    agreedToSuicideContract(): string {
      if (this.caseReport.patient.agreedToAntiSuicideContractAt != null) {
        return 'yes'
      }
      return 'no'
    },
    caseId(): string {
      return this.$route.params.caseId
    },
    demographics(): Demographics | undefined {
      const nodes: Demographics[] = this.caseReport?.demographics.nodes || []
      if (nodes.length === 0 || nodes[0] === undefined) {
        return undefined
      } else {
        return nodes[0]
      }
    },
    relatedTraumaliste(): any[] {
      const traumaliste = this.$store.getters['traumaliste/findBy']({ case_id: this.caseId })
      if (traumaliste != undefined && traumaliste != null) {
        //code true to X , false to -
        for (const key in traumaliste) {
          if (key.startsWith('item')) {
            if (traumaliste[key] == true) {
              traumaliste[key] = 'X'
            } else {
              traumaliste[key] = '-'
            }
          } else if (key.startsWith('is_trauma')) {
            if (traumaliste[key] == true) {
              traumaliste[key] = 'yes'
            } else {
              traumaliste[key] = 'no'
            }
          }
        }
        return [traumaliste]
      } else {
        return []
      }
    },
    relatedSibs(): any[] {
      const sibs = this.$store.getters['sbqr/filterBy']({ case_id: this.caseId })
      return sibs
    },
    interviewerName(): string {
      if (this.pickedCase?.members != null) {
        const member = this.pickedCase?.members.nodes.find(search => search.actsAsInterviewer)
        if (member != null) {
          return member.alias
        }
        return ''
      }
      return ''
    },
    counselorName(): string {
      if (this.pickedCase?.members != null) {
        const member = this.pickedCase?.members.nodes.find(search => search.actsAsCounselor)
        if (member != null) {
          return member.alias
        }
        return ''
      }
      return ''
    },
    interviewTerm() {
      const booking = this.bookings.nodes.find(el => el.interviewOfferByOfferId.isPost == false)

      if (booking != undefined && booking != null) {
        console.log('found booking', booking)

        const startDate = new Date(booking.interviewOfferByOfferId.timeSlot.start.value)
        const endDate = new Date(booking.interviewOfferByOfferId.timeSlot.end.value)

        return (
          startDate.toDateString() +
          ': ' +
          startDate.toLocaleTimeString() +
          ' - ' +
          endDate.toLocaleTimeString()
        )
      }
      return ''
    },
    interviewHasTakenPlace(): boolean {
      const interviewReport = this.$store.getters['interviewReports/filterBy']({
        case_id: this.caseId,
      })
      return interviewReport != undefined && interviewReport != null && interviewReport.length > 0
    },
    feedbackInterviewReportExisting(): boolean {
      const feedbackReport = this.$store.getters['feedbackInterviewReports/filterBy']({
        case_id: this.caseId,
      })
      return feedbackReport != undefined && feedbackReport != null && feedbackReport.length > 0
    },
    feedbackInteriewTerm() {
      const booking = this.bookings.nodes.find(el => el.interviewOfferByOfferId.isPost == true)
      if (booking != undefined && booking != null) {
        const startDate = new Date(booking.interviewOfferByOfferId.timeSlot.start.value)
        const endDate = new Date(booking.interviewOfferByOfferId.timeSlot.end.value)

        return (
          startDate.toDateString() +
          ': ' +
          startDate.toLocaleTimeString() +
          ' - ' +
          endDate.toLocaleTimeString()
        )
      }
      return ''
    },
    counselingQuestions() {
      const data = this.$store.getters['counselingQuestions/filterBy']({
        case_id: this.caseId,
      })
      return data
    },
    hasCounselingQuestions() {
      return (
        this.caseReport.counselingQuestions && this.caseReport.counselingQuestions.nodes.length > 0
      )
    },
    hasCorrectedQuestions() {
      return (
        this.counselingQuestions &&
        this.counselingQuestions.length == 2 &&
        this.counselingQuestions.find(a => a.step === 'correction') != null
      )
    },
    counselingQuestionClient() {
      if (this.hasCounselingQuestions) {
        return this.counselingQuestions[0]
      }
      return null
    },
    counselingQuestionsCorrection() {
      if (this.hasCorrectedQuestions) {
        return this.counselingQuestions.find(a => a.step === 'correction')
      }
      return null
    },
    screeningEndDate(): any {
      if (this.logs && this.logs.nodes.length > 0) {
        const screeningList = this.logs.nodes.filter(
          (i: { taskId: string }) => i.taskId === 'do-screening'
        )
        if (screeningList.length > 0) {
          return this.logs.nodes[0].endedAt
        } else {
          return null
        }
      }
      return null
    },
    screeningDateFormatted() {
      let screeningDates = ''
      if (this.logs && this.logs.nodes.length > 0) {
        const screeningList = this.logs.nodes.filter(
          (i: { taskId: string }) => i.taskId === 'do-screening'
        )
        if (screeningList.length > 0) {
          const logNode = screeningList[0]
          screeningDates = new Date(logNode.startedAt).toLocaleString()
          if (logNode.endedAt) {
            screeningDates += ' / ' + new Date(logNode.endedAt).toLocaleString()
          }
        }
      }
      return screeningDates
    },
    treatmentName() {
      let treatmentName = null
      const firstTreatment = this.firstTreatment
      if (firstTreatment != null) {
        if (firstTreatment.taskId === 'do-cbt-treatment') {
          treatmentName = 'CBT'
        } else if (firstTreatment.taskId === 'do-ipt-treatment') {
          treatmentName = 'IPT'
        } else if (firstTreatment.taskId === 'do-expo-treatment') {
          treatmentName = 'EXPO'
        } else if (firstTreatment.taskId === 'do-cr-treatment') {
          treatmentName = 'CR'
        }
      }
      return treatmentName
    },
    treatmentStartDate() {
      const firstTreatment = this.firstTreatment
      if (firstTreatment != null) {
        return new Date(firstTreatment.startedAt).toLocaleString()
      }
      return ''
    },
  },
  data(): {
    phq9Fields: string[]
    phq4Fields: string[]
    caseReport: CaseReport | null
    dropoutInProgress: Boolean
    countryNames: {
      [language: string]: { [code: number]: string }
    }
    locale: string
    traumaFields: string[]
    sibsFields: string[]
  } {
    return {
      locale: this.$i18n.locale,
      traumaFields: [
        'created_at',
        'time_of_measurement',
        'item_1',
        'item_2',
        'item_3',
        'item_4',
        'item_5',
        'item_6',
        'item_7',
        'item_8',
        'item_9',
        'item_10',
        'item_11',
        'item_12',
        'item_13',
        'item_14',
        'item_15',
        'item_16',
        'item_17',
        'item_18',
        'item_19',
        'item_20',
        'item_21',
        'item_22',
        'item_23',
        'item_24',
        'item_25',
        'is_traumatized',
      ],
      countryNames: require('@/locales/countries.yml'),
      phq9Fields: [
        'createdAt',
        'timeOfMeasurement',
        'item1',
        'item2',
        'item3',
        'item4',
        'item5',
        'item6',
        'item7',
        'item8',
        'item9',
        'itemSeverity',
        'score',
      ],
      phq4Fields: [
        'createdAt',
        'timeOfMeasurement',
        'item1',
        'item2',
        'item3',
        'item4',
        'scoreDepression',
        'scoreFear',
        'score',
      ],
      sibsFields: [
        'created_at',
        'time_of_measurement',
        'item_1',
        'item_2',
        'item_3',
        'item_4',
        'item_5',
        'item_6',
        'item_7',
        'item_8',
        'item_9',
      ],
      caseReport: null,
      dropoutInProgress: false,
    }
  },
  methods: {
    async dropoutUser(caseId) {
      if (window.confirm('You are about to dropout/anonymize case directly. Are you sure?')) {
        this.dropoutInProgress = true
        const http: AxiosInstance = this.$store.getters.http
        try {
          const response = await http.post(
            `/custom-api/workflows/anonymizeProcess/${caseId}`,
            null,
            {
              headers: {
                Accept: 'text/plain',
                'Content-Type': 'text/plain',
              },
            }
          )
          this.dropoutInProgress = false
          if (response.data === 'OK') {
            window.alert('Case was dropped out successfully')
          } else {
            window.alert('\\U26A0 Unexpected return value from dropout-Service : ' + response.data)
          }
        } catch (error) {
          console.error(error)
          this.dropoutInProgress = false

          if (error.response) {
            window.alert(
              `\\U1F6AB Server-Error on dropout-Service. Error is: ${error.response.status}`
            )
          } else if (error.request) {
            window.alert(`\\U1F6AB No response from Server`)
          } else {
            window.alert(`\\U1F6AB Error: ${error.message}`)
          }
        }
      }
    },
    mounted() {
      window.scrollTo(0, 0)
    },
  },
})
